module.exports = __webpack_public_path__ + "static/media/21_Gramm_Loss.ad99daf5.mp3";